import { render, staticRenderFns } from "./ProofTab-v2.vue?vue&type=template&id=ef45bcac&scoped=true&"
import script from "./ProofTab-v2.vue?vue&type=script&lang=js&"
export * from "./ProofTab-v2.vue?vue&type=script&lang=js&"
import style0 from "./ProofTab-v2.vue?vue&type=style&index=0&id=ef45bcac&prod&lang=scss&scoped=true&"
import style1 from "./ProofTab-v2.vue?vue&type=style&index=1&id=ef45bcac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef45bcac",
  null
  
)

export default component.exports